module.exports = __webpack_public_path__ + "img/user-edit.c8c04b5e.svg";